import {getData, LOGIN} from "../../storage";
import {isEmpty} from "../../utility";

const getMySubscriptionPackageAPI = (props) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMySubscriptionPackage(
                    data.token,
                    data.api_token,
                );
            }
        })
}

const updateMySubscriptionAPI = (props, id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.updateMySubscription(
                    data.token,
                    data.api_token,
                    id
                );
            }
        })
}

const getMySubscribersAPI = (props) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMySubscribers(
                    data.token,
                    data.api_token
                );
            }
        })
}

export default {
    getMySubscriptionPackageAPI,
    updateMySubscriptionAPI,
    getMySubscribersAPI
}